import {AttributeLink} from '@acng/frontend-stargazer';
import {set} from '@acng/frontend-bounty/dom/attribute.js';
import {guard, INTEGER, RECORD, STRING} from '@acng/frontend-rubicon';

/**
 * @group DOM Attribute
 */
const name = 'history-anchor';

AttributeLink(name, (element, value) => {
  //set(element, name, `${window.history.length}`);
  const {history} = window;
  const {anchors = {}} = history.state ?? {};
  ASSERT: guard(anchors, RECORD(STRING, INTEGER));
  console.log({...history.state})

  const {length} = history;
  const anchor = anchors[value];

  if (!anchor) {
    anchors[value] = history.length;
    const newState = {...history.state, anchors};
    console.log('put anchor', {value, length, newState});
    history.replaceState(newState, '');
  }

  DEBUG: if (anchor) console.log('exists', {value, anchor, length});
});

export {name as HISTORY_ANCHOR};
